import React from 'react';

import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEDemoTargetType, OEDemoTargets, OEDemoFeatureAccess, OEDemoStartSelectionData} from './oe-demo-model';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';

export default class OEDemoStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        let modules = OEDemoStartSelectionData.chooseModules();

        let targetTypeEntries = [
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.anatomy, stringId: 'start_view_title_anatomy', icon: OEIconCodes.demo.anatomyTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.histology, stringId: 'start_view_title_histology', icon: OEIconCodes.demo.histologyTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.orthopedic, stringId: 'start_view_title_orthopedic', icon: OEIconCodes.demo.orthopedicTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.ophthalmology, stringId: 'start_view_title_ophthalmology', icon: OEIconCodes.demo.ophthalmologyTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.toxicology, stringId: 'start_view_title_toxicology', icon: OEIconCodes.demo.toxicologyTarget},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.visceral, stringId: 'start_view_title_visceral', icon: OEIconCodes.demo.visceralTarget},
            // {type: OEProtoStartViewEntryTypes.targetType, targetType: OEDemoTargetType.cell, stringId: 'start_view_title_cell', icon: OEIconCodes.demo.cellTarget},
        ].filter(entry => modules.findIndex(module => module.id === entry.targetType) >= 0);

        this.entries = [
            {type: OEFNWelcomeEntryTypes.spacer, height: '4.25em' /*68*/},
            {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5625em' /*25*/},
                ...targetTypeEntries,
            {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
            {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '2.0625em' /*33*/}
        ];
    }

    render()    {
        return (
            <OEProtoStartView
                {...this.props}
                entries={this.entries}
                versionTargets={OEDemoTargets}
                featureAccess={OEDemoFeatureAccess}
                startSelectionData={OEDemoStartSelectionData}
            />
        );
    }
}